import { Box } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const CenterVh = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  height: "100vh"
});

export default CenterVh;
